import { Attribute, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'

import { CriadoresDeBinario } from './criador-de-binario.enum'

@JsonApiModelConfig({
    type: 'binarios'
})
export class Binario extends JsonApiModel {
    @Attribute() opcoes: any
    @Attribute() criador: CriadoresDeBinario
    @Attribute() url: string
    @Attribute() avisos: string[]

    get vazio(): boolean {
        return (
            this.avisos &&
            this.avisos.findIndex(aviso =>
                aviso.includes('Não existem lançamentos no período selecionado')
            ) !== -1
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/binario.model.ts